(() => {
  if (customElements.get('dyefor-free-case-signup')) return;
  const visible = element => element && element.getClientRects().length > 0
    && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).opacity !== '0';
  class FreeCaseSignup extends HTMLElement {
    connectedCallback() {
      this.launcher = this.querySelector('[data-signup-launcher]');
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      if (!this.launcher || !this.dialog?.showModal || !this.form) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.launcher.addEventListener('click', () => this.open(), options);
      this.querySelector('[data-signup-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('dyefor-signup-open');
        this.launcher.setAttribute('aria-expanded', 'false');
        this.syncLauncher();
        if (!this.launcher.hidden) this.launcher.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const items = [...this.dialog.querySelectorAll('button, input, a[href], select, textarea, iframe, [tabindex]')]
          .filter(el => !el.disabled && el.tabIndex >= 0 && visible(el));
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, options);
      // Keep Shopify's native POST and spam protection; never store the email in the browser.
      const returnTo = this.form.querySelector('[name="return_to"]');
      if (returnTo) {
        const url = new URL(location.href);
        url.searchParams.delete('customer_posted');
        returnTo.value = `${url.pathname}${url.search}#DyeforFreeCaseForm`;
      }
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.syncLauncher());
      };
      this.observer = new MutationObserver(schedule);
      this.observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden', 'open', 'style'] });
      window.addEventListener('resize', schedule, options);
      this.syncLauncher();
      if (location.hash === '#DyeforFreeCaseForm' && this.querySelector('[data-signup-success], [data-signup-error]')) this.open();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('dyefor-signup-open');
    }
    syncLauncher() {
      const blocked = this.dialog.open
        || document.body.matches('.dyefor-customizer-open, .custom-form-active, .dyefor-mobile-menu-open')
        || document.documentElement.classList.contains('dyefor-ai-direct-product')
        || [...document.querySelectorAll('cart-drawer.active, dialog[open], details-modal details[open], .dyefor-wishlist-modal:not([hidden]), #pandectes-banner, .varDlgCust, .cust-form-v3')].some(visible);
      if (this.launcher.hidden !== blocked) this.launcher.hidden = blocked;
    }
    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      document.body.classList.add('dyefor-signup-open');
      this.launcher.setAttribute('aria-expanded', 'true');
      this.syncLauncher();
      const target = this.querySelector('[data-signup-error], [data-signup-success], [name="contact[email]"]');
      target?.focus({ preventScroll: true });
    }
  }
  customElements.define('dyefor-free-case-signup', FreeCaseSignup);
})();
